// Типизация API-ошибок платформы Starling (общая для Light и Vision).
// Формат envelope: {error: {code: "snake_case", message: "...", details?: {...}}}
// (см. docs/api/openapi-m1.yaml D5 — та же форма в openapi-vision.yaml).

export interface ApiErrorEnvelope {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  };
}

export class ApiError extends Error {
  public readonly code: string;
  public readonly status: number;
  public readonly details?: Record<string, unknown>;

  constructor(code: string, message: string, status: number, details?: Record<string, unknown>) {
    super(message);
    this.name = 'ApiError';
    this.code = code;
    this.status = status;
    if (details !== undefined) {
      this.details = details;
    }
  }
}

// Сетевой сбой / неудачный JSON-парсинг / прочая инфра-боль.
// Отличается от ApiError тем, что код не от сервера, а от клиента.
export class NetworkError extends Error {
  public readonly underlying?: unknown;
  constructor(message: string, underlying?: unknown) {
    super(message);
    this.name = 'NetworkError';
    if (underlying !== undefined) this.underlying = underlying;
  }
}

export function isApiError(err: unknown): err is ApiError {
  return err instanceof ApiError;
}

export function isApiErrorEnvelope(value: unknown): value is ApiErrorEnvelope {
  if (typeof value !== 'object' || value === null) return false;
  const v = value as { error?: unknown };
  if (typeof v.error !== 'object' || v.error === null) return false;
  const e = v.error as { code?: unknown; message?: unknown };
  return typeof e.code === 'string' && typeof e.message === 'string';
}
